// O NOME DE UMA ETIQUETA NA TELA. O cadastro guarda "pensao-alimenticia";
// a tela mostra "PENSAO ALIMENTICIA" — o hífen é do cadastro, não do nome, e
// a etiqueta é sempre em MAIÚSCULAS (Victor, 16/09/2026). Era a regra do
// cartão da lista; o seletor, o filtro e o menu mostravam o cadastro cru
// (05/10/2026: em produção, 11 das 18 etiquetas têm hífen).
export const nomeDaEtiqueta = (titulo = '') =>
  titulo.replace(/-/g, ' ').toUpperCase();

const normalizar = (texto = '') =>
  texto
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[-\s]+/g, ' ')
    .trim();

// A busca acha pelo que a pessoa VÊ: "aposentadoria especial" acha
// "aposentadoria-especial", e "auxilio" acha "auxílio-acidente".
export const etiquetaCasa = (titulo, termo) =>
  normalizar(titulo).includes(normalizar(termo));
